<template>
  <div class="flex flex-col gap-5 text-xl font-bold border p-5 h-screen overflow-y-auto">
    <div class="min-h-[30px]">
      <span>更新時間 : </span>
      <a-radio-group v-model="selectedUpdateTimeType" :options="updateTimeArr" />
      <a-date-picker v-if="timerShow" show-time placeholder="Select Time" @change="onChange" />
    </div>

    <div>
      <span>更新範圍 : </span>
      <!-- <a-radio-group @change="PickArea()" v-model="selectedArea" :options="areaArr" /> -->
      <a-select @change="PickArea()" :default-value="areaArr[0]" v-model="selectedArea" placeholder="請選擇行政區" style="width: 120px">
        <a-select-option v-for="area in areaArr" :key="area">
          {{ area }}
        </a-select-option>
      </a-select>

      <a-select @change="PickCity()" :default-value="cityArr[0]" v-model="selecteCity" mode="multiple" placeholder="請選擇城市" :filter-option="filterOption" style="width: 120px">
        <a-select-option v-for="city in cityArr" :key="city">
          {{ city }}
        </a-select-option>
      </a-select>

      <a-select
        @change="PickCity()"
        :default-value="districtArr[0]"
        v-model="selecteDistrict"
        mode="multiple"
        placeholder="請選擇區域"
        :filter-option="filterOption"
        style="width: 120px"
      >
        <a-select-option v-for="district in districtArr" :key="district">
          {{ district }}
        </a-select-option>
      </a-select>
      <span class="ml-2">選擇共{{ selectedDeviceArr.length }}間</span>

      <div class="mt-3 flex items-start">
        <!-- disabled -->
        <a-select
          v-model="selectedDeviceArr"
          allowClear
          :maxTagCount="20"
          :maxTagTextLength="6"
          class="w-[575px]"
          mode="multiple"
          placeholder="請選擇欲更新機台"
          show-search
          :filter-option="false"
          @search="handleDeviceSearch"
          @dropdownVisibleChange="handleDeviceDropdownChange"
        >
          <a-select-option v-for="item of filteredDeviceList" :key="item.device_mac" :value="item.device_mac">
            {{ item.device_name }}
          </a-select-option>
        </a-select>
        <a-button class="ml-3" icon="download" :disabled="selectedDeviceArr.length === 0" @click="ExportSelectedDevices">
          匯出所選機台
        </a-button>
      </div>
    </div>

    <div class="flex">
      <span>更新備註與說明 : </span>
      <span class="inline-block w-[410px] ml-3">
        <a-textarea v-model="notes" placeholder="請輸入備註或更新說明" :auto-size="{ minRows: 2, maxRows: 6 }" />
      </span>
    </div>

    <!-- <a-upload :file-list="fileListSend" :remove="handleRemove" :before-upload="beforeUploadSend" name="codes" accept=".rar, .zip"> -->
    <div>
      <a-button class="w-[150px]" @click="PickUploadFile()">
        <a-icon type="upload" />
        點擊選擇檔案
      </a-button>
      <!-- </a-upload> -->
      <span class=" ml-5 px-2 py-1 rounded-xl hover:bg-gray-300">{{ uploadFileName }}</span>
    </div>

    <a-button type="primary" :loading="loading" :disabled="!uploadFileName" @click="handleUpload"> 確定上傳 </a-button>
    <!-- <a-button type="primary" @click="toggleList"> 確認<a-icon type="right" /> </a-button> -->
    <div
      @click.self="CloseUploadList"
      :class="{ hidden: !isListVisible, visible: isListVisible }"
      id="modal_overlay"
      class="backdrop overflow-hidden z-50 absolute inset-0 h-full w-full flex justify-center items-center"
    >
      <div class="container-group shadow-md rounded-xl bg-clip-border w-2/5 bg-white">
        <ul class="radio-group">
          <li class="radio-item" v-for="(file, index) in uploadFileList" :key="index">
            <input v-model="uploadFileName" type="radio" class="radio-btn" name="file" :id="'file-' + index" :value="file" />
            <label :for="'file-' + index" class="label">{{ file }}</label>
          </li>
        </ul>
        <div class="flex flex-row-reverse">
          <a-button @click="ToggleList()" type="primary">確認<a-icon type="right" /> </a-button>
        </div>
      </div>
    </div>

    <a-table @expand="GetUpdateDevice" :columns="columns" :data-source="updateList" :pagination="{ pageSize: 5 }">
      <div slot="expandedRowRender" slot-scope="record" style="margin: 0; padding: 8px 16px; background-color: #fafafa; border-radius: 4px;">
        <div style="margin-bottom: 8px; display: flex; align-items: center; flex-wrap: wrap;">
          <span style="font-weight: bold; color: #22c55e; margin-right: 12px; min-width: 80px;">成功下載：</span>
          <div style="display: flex; flex-wrap: wrap; gap: 6px;">
            <template v-if="record.devices && record.devices.filter(d => d.isuploaded !== 0).length > 0">
              <a-tag v-for="device in record.devices.filter(d => d.isuploaded !== 0)" :key="device.device_mac" color="green">
                {{ ShowDeviceName(device.device_mac) }}
              </a-tag>
            </template>
            <span v-else style="color: #8c8c8c;">無</span>
          </div>
        </div>
        <div style="display: flex; align-items: center; flex-wrap: wrap;">
          <span style="font-weight: bold; color: #ef4444; margin-right: 12px; min-width: 80px;">下載失敗：</span>
          <div style="display: flex; flex-wrap: wrap; gap: 6px; align-items: center;">
            <template v-if="record.devices && record.devices.filter(d => d.isuploaded === 0).length > 0">
              <a-tag v-for="device in record.devices.filter(d => d.isuploaded === 0)" :key="device.device_mac" color="red">
                {{ ShowDeviceName(device.device_mac) }}
              </a-tag>
              <a-button 
                size="small" 
                type="danger" 
                ghost 
                style="margin-left: 12px; border-radius: 4px; font-weight: bold;" 
                @click="retryFailedDevices(record.devices)"
              >
                <a-icon type="redo" />一鍵填入失敗機台進行重試
              </a-button>
            </template>
            <span v-else style="color: #8c8c8c;">無</span>
          </div>
        </div>
      </div>
    </a-table>
  </div>
</template>
<script>
import * as XLSX from 'xlsx'
import FileSaver from 'file-saver'

const DEFAULT_REGIONS = [
  { city_name: '台北市', area_name: '北部' },
  { city_name: '新北市', area_name: '北部' },
  { city_name: '基隆市', area_name: '北部' },
  { city_name: '桃園市', area_name: '北部' },
  { city_name: '新竹市', area_name: '北部' },
  { city_name: '新竹縣', area_name: '北部' },
  { city_name: '宜蘭縣', area_name: '北部' },
  { city_name: '苗栗縣', area_name: '中部' },
  { city_name: '台中市', area_name: '中部' },
  { city_name: '彰化縣', area_name: '中部' },
  { city_name: '南投縣', area_name: '中部' },
  { city_name: '雲林縣', area_name: '中部' },
  { city_name: '嘉義市', area_name: '南部' },
  { city_name: '嘉義縣', area_name: '南部' },
  { city_name: '台南市', area_name: '南部' },
  { city_name: '高雄市', area_name: '南部' },
  { city_name: '屏東縣', area_name: '南部' },
  { city_name: '花蓮縣', area_name: '東部' },
  { city_name: '台東縣', area_name: '東部' },
  { city_name: '澎湖縣', area_name: '離島' },
  { city_name: '金門縣', area_name: '離島' },
  { city_name: '連江縣', area_name: '離島' }
]

const CITY_NORMALIZATION_MAP = {
  台北: '台北市',
  臺北: '台北市',
  新北: '新北市',
  基隆: '基隆市',
  桃園: '桃園市',
  新竹: '新竹市',
  苗栗: '苗栗縣',
  台中: '台中市',
  臺中: '台中市',
  彰化: '彰化縣',
  南投: '南投縣',
  雲林: '雲林縣',
  嘉義: '嘉義市',
  台南: '台南市',
  臺南: '台南市',
  高雄: '高雄市',
  屏東: '屏東縣',
  宜蘭: '宜蘭縣',
  花蓮: '花蓮縣',
  台東: '台東縣',
  臺東: '台東縣',
  澎湖: '澎湖縣',
  金門: '金門縣',
  連江: '連江縣'
}

export default {
  data () {
    return {
      baseURL: this.GLOBAL.baseURL,
      basePort: this.GLOBAL.basePort,
      selectedFile: null,
      selectedUpdateTimeType: null,
      selectedUpdateTimestemp: null,
      timerShow: false,
      columns: [
        {
          title: '更新流水號',
          dataIndex: 'update_id',
          key: 'update_id',
          align: 'center'
        },
        {
          title: '通知更新時間',
          dataIndex: 'release_datetime',
          key: 'release_datetime',
          customRender: (text, record) => {
            return new Date(record.release_datetime).toLocaleString()
          }
        },
        { title: '地區', dataIndex: 'area', key: 'area', align: 'center' },
        {
          title: '城市',
          dataIndex: 'city',
          key: 'city',
          align: 'center',
          customRender: (text, record) => {
            const city = record.city
            if (city && Array.isArray(city) && city.length > 0) {
              return city.length > 3 ? city.slice(0, 3).join(', ') + '...' : city.join(', ')
            } else {
              return '--'
            }
          }
        },
        {
          title: '區域',
          dataIndex: 'district',
          key: 'district',
          align: 'center',
          customRender: (text, record) => {
            const district = record.district
            if (district && Array.isArray(district) && district.length > 0) {
              return district.length > 3 ? district.slice(0, 3).join(', ') + '...' : district.join(', ')
            } else {
              return '--'
            }
          }
        },
        { title: '更新內容', dataIndex: 'notes', key: 'notes', ellipsis: true },
        { title: '更新檔名', dataIndex: 'upload_file_name', key: 'upload_file_name' },
        {
          title: '更新時間',
          dataIndex: 'upload_datetime',
          key: 'upload_datetime',
          align: 'center',
          customRender: (text) => {
            if (!text) return '--'
            // 純數字字串 → Unix timestamp（秒），轉成本地可讀時間
            if (/^\d+$/.test(text)) {
              return new Date(Number(text) * 1000).toLocaleString()
            }
            // '即時' 或 '下次開機' 直接顯示
            return text
          }
        },
        {
          title: '發布總數',
          dataIndex: 'total_count',
          key: 'total_count',
          align: 'center',
          customRender: (text, record) => {
            return text !== undefined && text !== null ? text : 0
          }
        },
        {
          title: '成功數',
          dataIndex: 'success_count',
          key: 'success_count',
          align: 'center',
          customRender: (text, record) => {
            const count = text !== undefined && text !== null ? text : 0
            return this.$createElement('span', { style: { color: '#22c55e', fontWeight: 'bold' } }, count)
          }
        },
        {
          title: '失敗數',
          dataIndex: 'fail_count',
          key: 'fail_count',
          align: 'center',
          customRender: (text, record) => {
            const count = text !== undefined && text !== null ? text : 0
            return this.$createElement('span', { style: { color: '#ef4444', fontWeight: 'bold' } }, count)
          }
        }
      ],
      notes: '',
      selectedArea: '自選',
      selecteCity: [],
      selecteDistrict: [],
      selectedDeviceArr: [],
      fileList: [],
      fileListSend: [],
      uploadFileName: '',
      uploadDatetime: null,
      updateTimeArr: [
        { label: '即時', value: 0 },
        { label: '下次開機', value: 1 },
        { label: '指定時間', value: 2 }
      ],
      // areaArr: [
      //   { value: '全部', label: '全部' },
      //   { value: '北部', label: '北部' },
      //   { value: '中部', label: '中部' },
      //   { value: '南部', label: '南部' },
      //   { value: '東部', label: '東部' },
      //   { value: '離島', label: '離島' },
      //   { value: '自選', label: '自選' }
      // ],
      areaArr: ['全部', '北部', '中部', '南部', '東部', '離島', '其他', '自選'],
      storeList: [],
      versionList: [],
      regionList: [],
      updateDevice: [],
      updateList: [],
      cityArr: [],
      districtArr: [],
      uploadFileList: [],
      storesByArea: {},
      isListVisible: false,
      otaBatchSize: 50,
      otaBatchIntervalMs: 1000,
      loading: false,
      deviceSearchText: ''
    }
  },
  computed: {
    mqttClient: {
      get () {
        return this.$store.state.mqttClient
      },
      set () {}
    },
    deviceList: {
      get () {
        return this.$store.state.deviceList
      },
      set () {}
    },
    filteredDeviceList () {
      const searchText = (this.deviceSearchText || '').trim().toLowerCase()

      // 1. 根據關鍵字篩選符合的機台
      const matched = this.deviceList.filter(item => {
        return (item.device_name || '').toLowerCase().includes(searchText) ||
               (item.device_mac || '').toLowerCase().includes(searchText)
      })

      // 2. 限制顯示最多 100 筆
      const limitCount = 100
      const limited = matched.slice(0, limitCount)

      // 3. 強制將已被選取的機台包含在內，避免輸入框退化顯示為 MAC 碼
      const selectedSet = new Set(this.selectedDeviceArr)
      const result = [...limited]

      const limitedMacs = new Set(limited.map(item => item.device_mac))
      this.deviceList.forEach(item => {
        if (selectedSet.has(item.device_mac) && !limitedMacs.has(item.device_mac)) {
          result.push(item)
        }
      })

      return result
    }
  },
  watch: {
    selectedUpdateTimeType: {
      handler (newValue, oldValue) {
        if (newValue === 2) {
          this.timerShow = true
        } else {
          this.timerShow = false
        }
      }
    }
  },
  async mounted () {
    await this.GetUpdateList()
    await this.GetDeviceList()
    await this.GetRegionList()
    this.CategorizeStoresByArea()
  },
  methods: {
    sleep (ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms)
      })
    },
    async sendSwUpdateInBatches (payload) {
      for (let startIndex = 0; startIndex < this.selectedDeviceArr.length; startIndex += this.otaBatchSize) {
        const batch = this.selectedDeviceArr.slice(startIndex, startIndex + this.otaBatchSize)
        batch.forEach((mac) => {
          // eslint-disable-next-line no-undef
          const message = new Paho.MQTT.Message(payload)
          message.destinationName = `command/${mac}/swUpdate`
          this.mqttClient.send(message)
        })

        const hasNextBatch = startIndex + this.otaBatchSize < this.selectedDeviceArr.length
        if (hasNextBatch) {
          await this.sleep(this.otaBatchIntervalMs)
        }
      }
    },
    ShowDeviceName (mac) {
      const aa = this.deviceList.filter((item) => item.device_mac === mac)
      return aa[0].device_name
    },
    // 多選框最多只顯示 20 個標籤，匯出讓中控能看到完整的所選機台
    ExportSelectedDevices () {
      if (this.selectedDeviceArr.length === 0) return

      const deviceMap = new Map(this.deviceList.map((item) => [item.device_mac, item]))
      const exportData = this.selectedDeviceArr.map((mac) => ({
        裝置名稱: deviceMap.get(mac)?.device_name || '',
        'Mac Address': mac
      }))

      const ws = XLSX.utils.json_to_sheet(exportData)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, '所選機台')

      const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
      const blob = new Blob([excelBuffer], { type: 'application/octet-stream' })
      const area = this.selectedArea || '自選'
      FileSaver.saveAs(blob, `所選機台_${area}_${new Date().toISOString().slice(0, 10)}.xlsx`)
    },
    ToggleList () {
      this.isListVisible = !this.isListVisible
    },
    CloseUploadList () {
      this.isListVisible = false
    },
    PickUploadFile () {
      return new Promise((resolve, reject) => {
        this.axios
          .post(this.baseURL + this.basePort + '/update/getUploadFileList', {})
          .then((res) => {
            console.log(res.data)
            if (res.data.message === 'success') {
              this.uploadFileList = res.data.data
              this.isListVisible = true
              resolve(res.data.data) // 將成功的結果傳遞給 Promise
            } else {
              reject(res.data.errorMsg) // 將錯誤信息傳遞給 Promise
            }
          })
          .catch((error) => {
            console.error(error)
            reject(error) // 將錯誤信息傳遞給 Promise
          })
      })
    },
    filterOption (input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    GetUpdateDevice (expanded, record) {
      console.log(expanded)
      console.log(record)
      if (expanded) {
        return new Promise((resolve, reject) => {
          this.axios
            .post(this.baseURL + this.basePort + '/update/getUpdateDevice', {
              update_id: record.update_id
            })
            .then((res) => {
              console.log(res.data)
              if (res.data.message === 'success') {
                this.updateDevice = res.data.data
                const index = this.updateList.findIndex((item) => item.update_id === record.update_id)
                if (index !== -1) {
                  // 如果找到匹配的项，则更新devices键
                  this.$set(this.updateList[index], 'devices', res.data.data)
                } else {
                  // this.updateList.push({ update_id, devices })
                }
                resolve(res.data.data) // 將成功的結果傳遞給 Promise
              } else {
                reject(res.data.message) // 將錯誤信息傳遞給 Promise
              }
            })
            .catch((error) => {
              console.error(error)
              reject(error) // 將錯誤信息傳遞給 Promise
            })
        })
      }
    },
    getTagColor (isUploaded) {
      return isUploaded === 0 ? 'red' : 'green'
    },

    onChange (value, dateString) {
    //   console.log('Selected Time: ', value)
      console.log('Formatted Selected Time: ', dateString)
      const dateObject = new Date(dateString)
      this.selectedUpdateTimestemp = Math.floor(dateObject.getTime() / 1000)
    },
    PickArea () {
      this.selecteCity = []
      this.selecteDistrict = []
      if (!this.storesByArea[this.selectedArea] && this.selectedArea !== '全部') {
        this.selectedDeviceArr = []
        this.cityArr = []
        return
      }
      if (this.selectedArea === '全部') {
        this.selectedDeviceArr = this.deviceList.map((item) => item.device_mac)
        this.cityArr = []
      } else {
        this.selectedDeviceArr = this.storesByArea[this.selectedArea].map((item) => item.device_mac)
        const cityArr = this.storesByArea[this.selectedArea].map((item) => item.city)
        this.cityArr = [...new Set(cityArr.filter(Boolean))]
      }
    },
    PickCity () {
      // console.log(this.storesByArea[this.selectedArea])
      if (this.selecteCity.length < 1) {
        this.selecteDistrict = []
        this.districtArr = []
        this.PickArea()
      } else {
        // this.arrayC是依照地區抓出來的機台列表，再過濾出含有當下複數或單數所選想要的city的機台列表
        this.arrayC = this.storesByArea[this.selectedArea].filter((item) => this.selecteCity.includes(item.city))
        const districtArr = this.arrayC.map((item) => item.district)
        this.districtArr = [...new Set(districtArr)]

        if (this.selecteDistrict.length < 1) {
          console.log(2)
          this.selectedDeviceArr = this.arrayC.map((item) => item.device_mac)
        } else {
          console.log(3)
          this.selecteDistrict = this.selecteDistrict.filter((district) => this.districtArr.includes(district))
          if (this.selecteDistrict.length < 1) {
            this.PickCity()
          } else {
            const arrayD = this.arrayC.filter((item) => this.selecteDistrict.includes(item.district))
            this.selectedDeviceArr = arrayD.map((item) => item.device_mac)
          }
        }
      }
    },
    // PickDistrict () {
    //   const arrayD = this.arrayC.filter((item) => this.selecteDistrict.includes(item.district))
    //   console.log(arrayD)
    //   this.selectedDeviceArr = arrayD.map((item) => item.device_mac)
    // },
    beforeUpload (file) {
      this.fileList = [file]
      //   return false // 阻止默认上传行为
    },

    async handleUpload () {
      if (!this.uploadFileName) {
        this.$message.error('請先選擇更新檔案')
        return false
      }
      if (this.selectedUpdateTimeType === null || this.selectedUpdateTimeType === undefined) {
        this.$message.error('請選擇更新時間')
        return false
      }
      if (this.selectedUpdateTimeType === 2 && !this.selectedUpdateTimestemp) {
        this.$message.error('請選擇指定的更新時間')
        return false
      }
      if (!this.selectedDeviceArr || this.selectedDeviceArr.length === 0) {
        this.$message.error('請選擇至少一台欲更新的機台')
        return false
      }

      this.loading = true
      try {
        const updateRecordResult = await this.UpdateRecord()
        console.log(updateRecordResult)

        // 在 UpdateRecord 函數中整合 MQTT 消息的發送
        const inf = JSON.stringify({
          serial: updateRecordResult.data.update_id,
          type: this.selectedUpdateTimeType,
          file: this.uploadFileName,
          time: this.selectedUpdateTimestemp
        })
        console.log(inf)
        await this.sendSwUpdateInBatches(inf)
        this.$message.success('通知更新完成')
        
        await this.GetUpdateList()
        await this.GetDeviceList()
        await this.GetRegionList()
        this.CategorizeStoresByArea()
        
        // 發布完成後初始化填寫內容
        this.resetForm()
      } catch (error) {
        console.error(error)
        this.$message.error('發布失敗: ' + (error.message || '未知錯誤'))
      } finally {
        this.loading = false
      }
    },
    resetForm () {
      this.selectedUpdateTimeType = null
      this.selectedUpdateTimestemp = null
      this.timerShow = false
      this.selectedArea = '自選'
      this.selecteCity = []
      this.selecteDistrict = []
      this.selectedDeviceArr = []
      this.notes = ''
      this.uploadFileName = ''
      this.cityArr = []
      this.districtArr = []
    },
    MqttUpload () {},
    // UploadFile () {
    //   return new Promise((resolve, reject) => {
    //     // 使用FormData來包裝檔案
    //     const formData = new FormData()
    //     formData.append('codes', this.selectedFile) // 後端API需辨認 code 這個name ----uploads.single("codes")
    //     this.axios
    //       .post(this.baseURL + this.basePort + '/update/uploadCode', formData)
    //       .then((res) => {
    //         console.log(res.data)
    //         resolve(res.data) // 將成功的結果傳遞給 Promise
    //       })
    //       .catch((error) => {
    //         console.error(error)
    //         reject(error) // 將錯誤信息傳遞給 Promise
    //       })
    //   })
    // },
    UpdateRecord () {
      if (this.selectedUpdateTimeType === 2) {
        this.uploadDatetime = this.selectedUpdateTimestemp
      } else {
        this.uploadDatetime = this.updateTimeArr.find((item) => item.value === this.selectedUpdateTimeType)?.label
      }
      return new Promise((resolve, reject) => {
        this.axios
          .post(this.baseURL + this.basePort + '/update/insertCode', {
            upload_datetime: this.uploadDatetime,
            area: this.selectedArea,
            city: this.selecteCity,
            district: this.selecteDistrict,
            notes: this.notes,
            upload_deviceMac_array: this.selectedDeviceArr,
            upload_file_name: this.uploadFileName
          })
          .then((res) => {
            console.log(res.data)
            // this.uploadFileName = null
            resolve(res.data) // 將成功的結果傳遞給 Promise
          })
          .catch((error) => {
            console.error(error)
            reject(error) // 將錯誤信息傳遞給 Promise
          })
      })
    },
    GetStoreList () {
      return new Promise((resolve, reject) => {
        this.axios
          .post(this.baseURL + this.basePort + '/store/storeList', {})
          .then((res) => {
            console.log(res.data)
            if (res.data.message === 'success') {
              this.storeList = res.data.data
              resolve(res.data) // 將成功的結果傳遞給 Promise
            } else {
              reject(res.data.message) // 將錯誤信息傳遞給 Promise
            }
          })
          .catch((error) => {
            console.error(error)
            reject(error) // 將錯誤信息傳遞給 Promise
          })
      })
    },
    GetUpdateList () {
      return new Promise((resolve, reject) => {
        this.axios
          .post(this.baseURL + this.basePort + '/update/getUpdateList', {})
          .then((res) => {
            console.log(res.data)
            if (res.data.message === 'success') {
              this.updateList = res.data.data
              resolve(res.data.data) // 將成功的結果傳遞給 Promise
            } else {
              reject(res.data.message) // 將錯誤信息傳遞給 Promise
            }
          })
          .catch((error) => {
            console.error(error)
            reject(error) // 將錯誤信息傳遞給 Promise
          })
      })
    },
    GetUpdateDeviceList () {
      return new Promise((resolve, reject) => {
        this.axios
          .post(this.baseURL + this.basePort + '/update/getUpdateDeviceList', {})
          .then((res) => {
            console.log(res.data)
            if (res.data.message === 'success') {
              this.updateDeviceList = res.data.data

              resolve(res.data.data) // 將成功的結果傳遞給 Promise
            } else {
              reject(res.data.message) // 將錯誤信息傳遞給 Promise
            }
          })
          .catch((error) => {
            console.error(error)
            reject(error) // 將錯誤信息傳遞給 Promise
          })
      })
    },
    GetRegionList () {
      return new Promise((resolve, reject) => {
        this.axios
          .post(this.baseURL + this.basePort + '/store/regionList', {})
          .then((res) => {
            console.log(res.data)
            if (res.data.message === 'success') {
              this.regionList = res.data.data
              resolve(res.data) // 將成功的結果傳遞給 Promise
            } else {
              this.regionList = DEFAULT_REGIONS
              this.$message.warning('regionList 讀取失敗，已改用內建區域對照')
              resolve({ data: DEFAULT_REGIONS })
            }
          })
          .catch((error) => {
            console.error(error)
            this.regionList = DEFAULT_REGIONS
            this.$message.warning('regionList 讀取失敗，已改用內建區域對照')
            resolve({ data: DEFAULT_REGIONS })
          })
      })
    },
    GetDeviceList () {
      return new Promise((resolve, reject) => {
        this.axios
          .post(this.baseURL + this.basePort + '/device/deviceList', {})
          .then((res) => {
            console.log(res.data)
            if (res.data.message === 'success') {
              this.$store.commit('deviceList', res.data.data)
              resolve(res.data) // 將成功的結果傳遞給 Promise
            } else {
              reject(res.data.message) // 將錯誤信息傳遞給 Promise
            }
          })
          .catch((error) => {
            console.error(error)
            reject(error) // 將錯誤信息傳遞給 Promise
          })
      })
    },
    CategorizeStoresByArea () {
      this.storesByArea = {
        北部: [],
        中部: [],
        南部: [],
        東部: [],
        離島: [],
        其他: []
      }

      this.deviceList.forEach((device) => {
        const normalizedCity = this.NormalizeCity(device.city)
        const normalizedDevice = { ...device, city: normalizedCity }
        const area = this.GetAreaByCity(normalizedCity)
        if (area) {
          this.storesByArea[area].push(normalizedDevice)
        } else {
          this.storesByArea['其他'].push(normalizedDevice)
        }
      })

      // storesByArea 包含了按照區域分類的店家陣列
      console.log(this.storesByArea)
    },
    NormalizeCity (city) {
      if (!city || typeof city !== 'string') {
        return null
      }

      const normalized = city.trim().replace(/臺/g, '台')

      if (CITY_NORMALIZATION_MAP[normalized]) {
        return CITY_NORMALIZATION_MAP[normalized]
      }

      if (normalized.endsWith('市') || normalized.endsWith('縣')) {
        return normalized
      }

      return null
    },
    GetAreaByCity (city) {
      if (!city) {
        return null
      }

      const matchedRegion = this.regionList.find((region) => region.city_name === city)
      return matchedRegion ? matchedRegion.area_name : null
    },
    // handleRemove (file) {
    //   const index = this.fileListSend.indexOf(file)
    //   const newFileList = this.fileListSend.slice()
    //   newFileList.splice(index, 1)
    //   this.fileListSend = newFileList
    //   this.selectedFile = null
    // },
    //  beforeUploadSend (file) {
    //   console.log(file)
    //   this.uploadFileName = file.name
    //   this.selectedFile = file
    //   this.fileListSend = [file]
    //   return false // 阻止默认上传行为
    // }
    handleDeviceSearch (value) {
      this.deviceSearchText = value || ''
    },
    handleDeviceDropdownChange (open) {
      if (!open) {
        this.deviceSearchText = ''
      }
    },
    retryFailedDevices (devices) {
      if (!devices || devices.length === 0) {
        this.$message.info('尚未讀取到更新機台清單，請稍後重試！')
        return
      }
      const failedMacs = devices.filter(d => d.isuploaded === 0).map(d => d.device_mac)
      if (failedMacs.length === 0) {
        this.$message.info('此更新任務沒有失敗的機台！')
        return
      }
      this.selectedDeviceArr = failedMacs
      this.$message.success(`已將 ${failedMacs.length} 台失敗機台填入上方選單，請選擇更新檔案後重新發布！`)
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }
}
</script>

<style lang="css" scoped>
.ant-table-thead > tr > th {
  text-align: center !important;
  border: 1px solid black;
}

.ant-table .ant-table-container .ant-table-content .ant-table-header th {
  text-align: center;
}

.container-group {
  border: 1px solid black;
  padding: 20px;
}
.radio-item {
  list-style-type: none;
  position: relative;
}
.radio-item:hover > .label {
  color: blueviolet;
}
.radio-item:hover > .label::before {
  border: 0.1rem solid blueviolet;
  margin-right: 1rem;
}
.radio-btn {
  position: absolute;
  opacity: 0;
  visibility: hidden;
}
.radio-btn:checked + .label {
  color: blueviolet;
}
.radio-btn:checked + .label::before {
  margin-right: 1rem;
  border: 0.1rem solid rgb(0, 128, 255);
  background: blueviolet;
}

.radio-item .label {
  display: flex;
  align-items: center;
  /* padding: 0.5rem 0; */
  color: black;
  font-size: 0.8rem;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.25s linear;
}

.radio-item .label::before {
  display: inline-block;
  content: "";
  height: 1.12rem;
  width: 1.12rem;
  margin-right: 0.625rem;
  border: 0.1rem solid black;
  border-radius: 50%;
  transition: all 0.25s linear;
}

.backdrop {
  backdrop-filter: blur(5px);
}

.hidden {
  display: none;
}

.visible {
  display: flex; /* 使用flex來確保內部元素可以居中 */
  justify-content: center;
  align-items: center;
  animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
  from {
    transform: scale(0);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}
</style>
